import {
  DrawerMenuItemSubmenuLinkType,
  Icon,
  useColorScheme,
  useHover,
  useLocales,
} from "@/lib/main";
import { CSSProperties } from "react";
import { NavLink, useLocation } from "react-router";

type Props = {
  isHashLinks?: boolean;
  level?: number;
  submenuItem: DrawerMenuItemSubmenuLinkType;
  setIsDrawerOpen: (isDrawerOpen: boolean) => void;
};

export default function DrawerMenuItemSubmenuLink({
  isHashLinks,
  level = 2,
  submenuItem,
  setIsDrawerOpen,
}: Props) {
  const location = useLocation();
  const l = useLocales();
  const { colorScheme } = useColorScheme();
  const { isHovered, onMouseEnter, onMouseLeave } = useHover();

  const handleClick = () => {
    setIsDrawerOpen(false);
    window.scrollTo(0, 0);
  };

  const currentLocation = isHashLinks
    ? location.pathname + location.hash
    : location.pathname;
  const isActive = submenuItem.to === currentLocation;

  const rowPadding =
    level <= 1
      ? "var(--page-padding-horizontal)"
      : `calc(var(--page-padding-horizontal) + (${level - 1} * var(--spacing-2xl)))`;

  const liStyle: CSSProperties = {
    display: "flex",
    alignItems: "center",

    width: "100%",

    borderBottom: "var(--border-width-xs) solid var(--color-border-subtle)",

    backgroundColor: isHovered
      ? colorScheme === "dark"
        ? "var(--color-background-frame)"
        : "var(--color-background-canvas)"
      : "transparent",
  };

  const linkStyle: CSSProperties = {
    display: "flex",
    gap: "var(--spacing-sm)",
    alignItems: "center",

    width: "100%",
    paddingTop: "var(--spacing-md)",
    paddingBottom: "var(--spacing-md)",
    paddingInlineStart: rowPadding,
    paddingInlineEnd: rowPadding,

    fontSize: "var(--font-size-drawer-item)",
  };

  return (
    <li
      onClick={handleClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      style={liStyle}
    >
      <NavLink
        className={() => {
          return isActive ? "font-color-nav active" : "font-color-nav";
        }}
        style={linkStyle}
        to={submenuItem.to}
      >
        <Icon
          color={isActive ? "active" : "secondary"}
          name={submenuItem.icon ?? (level > 2 ? "circle" : "circle-solid")}
          size={submenuItem.icon ? "md" : "xs"}
        />
        {l(submenuItem.title)}
      </NavLink>
    </li>
  );
}
